import { createUser } from './create-user.backend';
import { put } from 'redux-saga/effects';
import { createUserFail, createUserSuccess } from './actions';
import {
    makeErrorPayload,
    makeSuccessPayload
} from '../../../../../../shared/helpers/payload.helper';
import {
    setErrorToast,
    setSuccessToast
} from '../../../../../../shared/toast/redux/actions';
import { fetchUsers } from '../../redux/user-list/actions';

export function* createUserSaga(action) {
    try {
        const response = yield createUser(action.payload);
        yield put(createUserSuccess(response));
        yield put(fetchUsers());
        yield put(
            setSuccessToast(makeSuccessPayload('User created successfully.'))
        );
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(createUserFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
